import React from 'react';
import _ from 'lodash';
import RFField from '../../../components/Form/RFField';

const SaleForm = props => {
  const {
    dataSale,
    selectedPrices,
    selectSale,
  } = props;

  const renderForm = () => {
    const prices = [];
    let styleCenter = { textAlign: 'center' };
    let paddingTop = { paddingTop: 11 };
    if(dataSale){
      dataSale.forEach( price => {
        const nameAzon = "form-sale-id-" + price.id;
        const nameAr = "form-sale-price-" + price.id;
        const isSelected = selectedPrices && selectedPrices.includes(price.id);

        prices.push(
          <div className={"row price-round " + (isSelected ? "price-selected" : "price-unselected")} id="priceRow" key={price.id} onClick={() => selectSale(price.id)} style={{ paddingBottom: 8, paddingTop: 8, marginTop: 3, marginBottom: 3 }} >
            <div className="col-md-6" style={{paddingLeft: 8, paddingRight: 4}}>
              <RFField
                disabled
                className="price-input"
                name={nameAzon}
                value={price.azonosito}
                style={{...styleCenter, ...paddingTop, pointerEvents: 'none'}}
              />
            </div>
            <div className="col-md-6" style={{ paddingLeft: 4, paddingRight: 8 }}>
              <RFField
                disabled
                className="price-input"
                name={nameAr}
                value={price.ar}
                style={{...styleCenter, ...paddingTop, pointerEvents: 'none'}}
              />
            </div>
          </div>
        );
      });
    }

    return (
      <React.Fragment>
        <div className='d-flex'>
          <div className='col-6 pr-0' style={styleCenter}>Kártya azonosító:</div>
          <div className='col-6 pl-0' style={styleCenter}>Ár:</div>
        </div>
        {prices}
      </React.Fragment>
    );
  }
  
  return (
    <div className="row">
      <div className="col-md-12">
        <div className='col'>
          {renderForm()}
        </div>
      </div>
    </div>
  );
}

export default SaleForm;